/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: mutations.ts
 * Class: mutations.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { MutationTree } from 'vuex';
import { NewsItem, NewsState } from './types';
import { MutationRequestError, MutationRequestStatus } from '../types';
import { MissingTranslation } from '../../types/missingTranslation';

export const mutations: MutationTree<NewsState> = {
  newsListLoading(state) {
    state.newsList.error = undefined;
    state.newsList.status = MutationRequestStatus.LOADING;
  },
  newsListLoaded(state, payload: Array<NewsItem>) {
    state.newsList.error = undefined;
    state.newsList.data = state.newsList.data.concat(payload);
    state.newsList.status = MutationRequestStatus.SUCCESS;
  },
  newsListError(state, payload: MutationRequestError<null>) {
    state.newsList.error = payload;
    state.newsList.status = MutationRequestStatus.ERROR;
  },
  newsLoading(state) {
    state.news.error = undefined;
    state.news.status = MutationRequestStatus.LOADING;
  },
  newsLoaded(state, payload: NewsItem) {
    state.news.error = undefined;
    state.news.data = payload;
    state.news.status = MutationRequestStatus.SUCCESS;
  },
  newsError(state, payload: MutationRequestError<MissingTranslation>) {
    state.news.error = payload;
    state.news.status = MutationRequestStatus.ERROR;
  },
};
